(ns hai.admin-ui.profile.browser-extension
  "The Chrome extension section of the profile page: the settings the extension
  reads from the user's server-side config."
  (:require
   [hai.admin-ui.profile.setting-row :as row]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.web-app.auth :as auth]))

(def section-title "Chrome extension")

(def lead-text "How the Humble extension shows up in your browser.")

(defn settings-view []
  (let [identity @(<s :auth/identity)]
    [row/setting-list
     [row/setting-row-view
      {:label       auth/bookmark-toggle-label
       :description auth/bookmark-toggle-description
       :checked?    (boolean (:user-config.bookmark/visible? identity))
       :on-change   #(>e [::auth/set-bookmark-visible %])}]
     [row/setting-row-view
      {:label       auth/newtab-toggle-settings-label
       :description auth/newtab-toggle-description
       :checked?    (boolean (:user-config.newtab/override? identity))
       :on-change   #(>e [::auth/set-newtab-override %])}]]))
